import React, { useEffect } from 'react'
import './input-modal-component.scss'

interface InputModalProps {
  children?: React.ReactNode
  /** Clicking the dimmed backdrop invokes this (e.g. close modal). Escape also closes. */
  onBackdropClick?: () => void
}

function InputModal({ children, onBackdropClick }: InputModalProps) {
  useEffect(() => {
    if (!onBackdropClick) {
      return undefined
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onBackdropClick()
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onBackdropClick])

  const handleBackdrop = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target !== e.currentTarget) {
      return
    }
    onBackdropClick?.()
  }

  return (
    <div className='modal-container' onClick={onBackdropClick ? handleBackdrop : undefined}>
      <div className='modal-container__content' onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  )
}

export { InputModal }
